import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import DataPanel from "../DataPanel";
import SpringMaterialDetails from "./SpringMaterialDetails";
import { useState } from "react";

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
    options: {}
  },
  {
    name: 'diameter',
    label: 'Średnica sprężyny [mm]',
    options: {}
  },
  {
    name: 'height',
    label: 'Wysokość sprężyny [mm]',
    options: {}
  },
  {
    name: 'thickness',
    label: 'Średnica (grubość) drutu [mm]',
    options: {}
  },
  {
    name: 'unitPrice',
    label: 'Cena za oczko [zł]',
    options: {}
  }
];

const SpringMaterialsPanel = () => {
  const [pocketSpringMaterialsAccordionExpanded, setPocketSpringMaterialsAccordionExpanded] = useState<boolean>(true);
  const [bonnellSpringMaterialsAccordionExpanded, setBonnellSpringMaterialsAccordionExpanded] = useState<boolean>(true);

  const handleBonnellSpringMaterialsAccordionChanged = (expanded: boolean) =>
    setBonnellSpringMaterialsAccordionExpanded(expanded);

  const handlePocketSpringMaterialsAccordionChanged = (expanded: boolean) =>
    setPocketSpringMaterialsAccordionExpanded(expanded);

  return <main>
    <Accordion
        expanded={ bonnellSpringMaterialsAccordionExpanded }
        onChange={ (event, expanded) => handleBonnellSpringMaterialsAccordionChanged(expanded) }
    >
      <AccordionSummary>
        {bonnellSpringMaterialsAccordionExpanded ? 'Zwiń' : 'Rozwiń'} sprężyny Bonnell
      </AccordionSummary>
      <AccordionDetails classes={{ }}>
        <DataPanel
          tableSearchEnabled
          title='Sprężyny Bonnell'
          resource='bonnell-spring-materials'
          columns={ columns }
          renderDetails={(properties) => <SpringMaterialDetails { ...properties } purpose='BONNELL' />}
        />
      </AccordionDetails>
    </Accordion>
    <Accordion
        expanded={ pocketSpringMaterialsAccordionExpanded }
        onChange={ (event, expanded) => handlePocketSpringMaterialsAccordionChanged(expanded) }>
      <AccordionSummary>{pocketSpringMaterialsAccordionExpanded ? 'Zwiń' : 'Rozwiń'} sprężyny Pocket</AccordionSummary>
      <AccordionDetails>
        <DataPanel
          tableSearchEnabled
          title='Sprężyny Pocket'
          resource='pocket-spring-materials'
          columns={ columns }
          renderDetails={(properties) => <SpringMaterialDetails { ...properties } purpose='POCKET' />}
        />
      </AccordionDetails>
    </Accordion>
  </main>;
};
export default SpringMaterialsPanel;